<template>
  <app-panel>
    <b-row
      class="panel-header"
      slot="panel-header"
      @click="setMetadata.baseDataVisible = !setMetadata.baseDataVisible"
    >
      <b-col>
        <label>{{ title }}</label>
      </b-col>
      <b-col cols="auto">
        <s-collapse-expand-button :value="setMetadata.baseDataVisible"/>
      </b-col>
    </b-row>
    <b-collapse
      id="baseDataCollapse"
      slot="panel-body"
      :visible="setMetadata.baseDataVisible"
    >
      <b-container fluid>
        <b-row class="justify-content-between flex-lg-nowrap">
          <b-col
            lg="auto"
            xs="12">
            <b-row
              class="justify-content-end"
              v-for="(lineData, index) in leftLines"
              :key="index"
            >
              <b-col
                class="panel-data__label"
                lg="auto"
                xs="12"
              >{{lineData.label}}</b-col>
              <b-col
                class="panel-data__value"
                lg="2"
                xs="12"
              >{{lineData.value}}</b-col>
            </b-row>
          </b-col>
          <b-col lg="7" xs="12">
            <b-row
              v-for="(lineData, index) in rightLines"
              :key="index"
            >
              <b-col
                class="panel-data__label"
                lg="10"
                xs="12"
              >{{lineData.label}}</b-col>
              <b-col
                class="panel-data__value"
                lg="2"
                xs="12"
              >{{lineData.value}}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>
  </app-panel>
</template>

<script>
export default {
  props: {
    setMetadata: Object,
  },
  computed: {
    title() {
      return this.$t('sensors.regulation-sets.set-title', {
        name: this.setMetadata.set.number,
      });
    },
    leftLines() {
      return [
        {
          label: this.$t('sensors.regulation-sets.nominal-reference-voltage'),
          value: this.setMetadata.set.nominalReferenceVoltage,
        },
        {
          label: this.$t('sensors.regulation-sets.ur-voltage-drop'),
          value: this.setMetadata.set.urVoltageDrop,
        },
        {
          label: this.$t('sensors.regulation-sets.compensation-z'),
          value: this.setMetadata.set.compensationZ,
        },
        {
          label: this.$t('sensors.regulation-sets.timing-type'),
          value: this.setMetadata.set.timingType,
        },
      ];
    },
    rightLines() {
      return [
        {
          label: this.$t('sensors.regulation-sets.type-of-line-drop-compensation'),
          value: this.setMetadata.set.typeOfLineDropCompensation,
        },
        {
          label: this.$t('sensors.regulation-sets.ux-voltage-drop'),
          value: this.setMetadata.set.uxVoltageDrop,
        },
        {
          label: this.$t('sensors.regulation-sets.compensation-limit'),
          value: this.setMetadata.set.compensationLimit,
        },
        {
          label: this.$t('sensors.regulation-sets.timing-for-subsequent-operations'),
          value: this.setMetadata.set.timingForSubsequentOperations,
        },
      ];
    },
  },
};
</script>
<style scoped lang="sass">
@import "src/styles/defaults/mobile-first"

.panel-data
  box-sizing: content-box
  &:hover
    cursor: pointer
  &__wrapper
    page-break-inside: avoid
  &__list
    display: flex
    flex-wrap: wrap
    padding-left: 0
  &__label
    text-align: right
    padding: 0 1rem
    font-weight: 600
    margin-bottom: 0.5rem
    +media-max-md()
      text-align: center
  &__value
    padding: 0 1rem
    white-space: nowrap
    +media-max-md()
      text-align: center

</style>
